export * from '@primevue/core/config';
export { default } from '@primevue/core/config';
//# sourceMappingURL=index.mjs.map
